export enum UploadFormat {
  JSON = "JSON",
  GeoJSON = "GeoJSON",
}
